import { Play, Feather } from "lucide-react";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1751042332709-5bf144c05c02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwc3RhZ2UlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzc3NTg0NDk0fDA&ixlib=rb-4.1.0&q=85"
          alt="Stage lights"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#050505]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent" />
      </div>

      {/* Cross motif */}
      <div className="absolute right-10 top-1/3 pointer-events-none pulse-glow hidden md:block">
        <svg width="160" height="240" viewBox="0 0 160 240" fill="none">
          <rect x="70" y="30" width="20" height="180" fill="#D4AF37" fillOpacity="0.3" />
          <rect x="20" y="80" width="120" height="20" fill="#D4AF37" fillOpacity="0.3" />
          <rect x="75" y="30" width="10" height="180" fill="#D4AF37" fillOpacity="0.6" />
          <rect x="20" y="85" width="120" height="10" fill="#D4AF37" fillOpacity="0.6" />
        </svg>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-24 md:pb-32 w-full">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">
              Big Spring, TX · Rap · Gospel
            </span>
          </div>

          <h1 className="font-display font-black tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] leading-[0.9]">
            TEK<span className="text-[#D4AF37]">RECK</span>
          </h1>

          <p className="mt-8 max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed">
            Bringing Good News through rhythm. A journey from darkness into the
            Light — rap, testimony, and collaboration rooted in the Gospel of
            Jesus Christ.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="hero-listen-button"
              onClick={() => scrollTo("music")}
              className="group inline-flex items-center gap-3 h-12 px-7 bg-[#D4AF37] text-black text-sm uppercase tracking-[0.2em] font-semibold hover:bg-[#F1C40F] transition-colors"
            >
              <Play size={16} className="group-hover:translate-x-0.5 transition-transform" />
              Listen Now
            </button>
            <button
              data-testid="hero-testimony-button"
              onClick={() => scrollTo("faith")}
              className="inline-flex items-center gap-3 h-12 px-7 border border-white/20 text-white text-sm uppercase tracking-[0.2em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
            >
              <Feather size={16} />
              My Testimony
            </button>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-8 max-w-xl">
            <Stat label="Followers" value="312" />
            <Stat label="Plays" value="1.07K" />
            <Stat label="Journey" value="Since '19" />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/40 text-[10px] uppercase tracking-[0.4em] animate-pulse">
        Scroll ↓
      </div>
    </section>
  );
};

const Stat = ({ label, value }) => (
  <div>
    <div className="font-display text-3xl md:text-4xl text-white">{value}</div>
    <div className="text-[10px] uppercase tracking-[0.3em] text-white/50 mt-1">
      {label}
    </div>
  </div>
);
